import React from 'react';

export function HeaderSnowMountains({ snowHeight, isWinterEvent, snowmanPuffs }) {
  return (
    <>
      <svg viewBox="0 0 1440 100" className="snow-mountains-svg" preserveAspectRatio="none">
        <defs>
          <linearGradient id="snowGradReal1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="1" />
            <stop offset="50%" stopColor="#ffffff" stopOpacity="0.98" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0.95" />
          </linearGradient>
              <linearGradient id="snowGradReal2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.9" />
              </linearGradient>
              <linearGradient id="snowGradReal3" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.8" />
              </linearGradient>
              
              {/* Schatten für Tiefe */}
              <linearGradient id="snowShadow" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.4" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.2" />
              </linearGradient>
            </defs>
            
            {/* Schatten-Layer für Tiefe */}
            <path 
              className="snow-shadow" 
              d={`M0,${102 - (snowHeight * 16)} Q82,${102 - (snowHeight * 20)} 182,${102 - (snowHeight * 15)} T362,${102 - (snowHeight * 19)} T542,${102 - (snowHeight * 12)} T722,${102 - (snowHeight * 22)} T902,${102 - (snowHeight * 16)} T1082,${102 - (snowHeight * 21)} T1262,${102 - (snowHeight * 14)} T1440,${102 - (snowHeight * 19)} L1440,100 L0,100 Z`}
              fill="url(#snowShadow)" 
            />
            
            {/* Dynamische Schneehöhen - wachsen von 0 bis max 56px */}
            
            {/* Hintere Schicht - sanfte Hügel (wachsen zuerst) */}
            <path 
              className="snow-layer snow-layer-3" 
              d={`M0,${100 - (snowHeight * 18)} Q85,${100 - (snowHeight * 22)} 185,${100 - (snowHeight * 16)} T365,${100 - (snowHeight * 21)} T545,${100 - (snowHeight * 15)} T725,${100 - (snowHeight * 24)} T905,${100 - (snowHeight * 18)} T1085,${100 - (snowHeight * 22)} T1265,${100 - (snowHeight * 16)} T1440,${100 - (snowHeight * 21)} L1440,100 L0,100 Z`}
              fill="url(#snowGradReal3)" 
              style={{opacity: Math.max(0.6, Math.min(snowHeight * 1.2, 1))}}
            />
            
            {/* Mittlere Schicht - größere Hügel */}
            <path 
              className="snow-layer snow-layer-2" 
              d={`M0,${100 - (snowHeight * 25)} Q125,${100 - (snowHeight * 31)} 245,${100 - (snowHeight * 27)} T485,${100 - (snowHeight * 33)} T725,${100 - (snowHeight * 24)} T965,${100 - (snowHeight * 36)} T1205,${100 - (snowHeight * 28)} T1440,${100 - (snowHeight * 31)} L1440,100 L0,100 Z`}
              fill="url(#snowGradReal2)" 
              style={{opacity: Math.min(snowHeight * 1.8, 1)}}
            />
            
            {/* Vordere Schicht - höchste Berge mit mehr Details - max 56px */}
            <path 
              className="snow-layer snow-layer-1" 
              d={`M0,${100 - (snowHeight * 30)} Q65,${100 - (snowHeight * 43)} 155,${100 - (snowHeight * 36)} Q245,${100 - (snowHeight * 25)} 335,${100 - (snowHeight * 45)} Q425,${100 - (snowHeight * 33)} 515,${100 - (snowHeight * 49)} Q605,${100 - (snowHeight * 54)} 695,${100 - (snowHeight * 31)} Q785,${100 - (snowHeight * 45)} 875,${100 - (snowHeight * 27)} Q965,${100 - (snowHeight * 53)} 1055,${100 - (snowHeight * 37)} Q1145,${100 - (snowHeight * 28)} 1235,${100 - (snowHeight * 54)} Q1325,${100 - (snowHeight * 33)} 1385,${100 - (snowHeight * 56)} Q1415,${100 - (snowHeight * 39)} 1440,${100 - (snowHeight * 49)} L1440,100 L0,100 Z`}
              fill="url(#snowGradReal1)" 
              style={{opacity: Math.min(snowHeight * 2.2, 1)}}
            />
          </svg>
          
          {/* Dynamische Schnee-Glitzer */}
          <div className="snow-sparkles" style={{opacity: Math.min(snowHeight * 3, 1)}}>
            <span className="snow-sparkle" style={{'--x': `${5 + snowHeight * 2}%`, '--delay': '0s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${15 + snowHeight * 1}%`, '--delay': '1.5s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${28 - snowHeight * 1}%`, '--delay': '0.8s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${42 + snowHeight * 3}%`, '--delay': '2.2s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${55 - snowHeight * 2}%`, '--delay': '0.3s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${68 + snowHeight * 1}%`, '--delay': '1.8s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${78 - snowHeight * 1}%`, '--delay': '1.1s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${88 + snowHeight * 2}%`, '--delay': '2.5s'}}></span>
            <span className="snow-sparkle" style={{'--x': `${95 - snowHeight * 3}%`, '--delay': '0.6s'}}></span>
          </div>
          
          {/* Moderner Schneemann der O2-Symbole pustet - NUR bei Winter */}
          {isWinterEvent && snowHeight > 0.5 && (
            <div 
              className="snowman-winter-right"
              style={{opacity: Math.min((snowHeight - 0.5) * 2.5, 1)}}
            >
              {/* Gepustete Symbole die nach oben schweben */}
              {snowmanPuffs.map(puff => (
                <svg 
                  key={puff.id}
                  className="snowman-puff"
                  viewBox="0 0 24 24"
                  style={{
                    position: 'absolute',
                    left: '50%',
                    bottom: '75%',
                    width: `${puff.size}px`,
                    height: `${puff.size}px`,
                    transform: `translateX(-50%)`,
                    '--drift': `${puff.drift}px`,
                    animationDuration: `${puff.duration}s`,
                    animationDelay: `${puff.delay}s`
                  }}
                >
                  {puff.type === 'o2' && (
                    <g fill="none" stroke="#00d4ff" strokeWidth="1.5">
                      <circle cx="8" cy="12" r="5" />
                      <text x="15" y="16" fill="#00d4ff" fontSize="10" fontWeight="bold">2</text>
                    </g>
                  )}
                  {puff.type === 'wifi' && (
                    <g fill="none" stroke="#00d4ff" strokeWidth="1.5" strokeLinecap="round">
                      <path d="M2 8.5c3.5-3 6.5-4 10-4s6.5 1 10 4" />
                      <path d="M5 12c2.5-2 4.5-3 7-3s4.5 1 7 3" />
                      <path d="M8.5 15.5c1.5-1 2.5-1.5 3.5-1.5s2 .5 3.5 1.5" />
                      <circle cx="12" cy="19" r="1.5" fill="#00d4ff" />
                    </g>
                  )}
                  {puff.type === 'smartphone' && (
                    <g fill="none" stroke="#00d4ff" strokeWidth="1.5" strokeLinecap="round">
                      <rect x="6" y="2" width="12" height="20" rx="2" />
                      <circle cx="12" cy="18" r="1" fill="#00d4ff" />
                      <path d="M10 5h4" />
                    </g>
                  )}
                  {puff.type === 'signal' && (
                    <g fill="none" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round">
                      <path d="M4 18v-2" />
                      <path d="M8 18v-5" />
                      <path d="M12 18v-8" />
                      <path d="M16 18v-11" />
                      <path d="M20 18v-14" />
                    </g>
                  )}
                </svg>
              ))}
              
              {/* Moderner Vektor-Schneemann */}
              <svg viewBox="0 0 60 80" className="snowman-winter-svg">
                <defs>
                  <linearGradient id="snowGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="100%" stopColor="#e2e8f0" />
                  </linearGradient>
                  <linearGradient id="scarfGrad" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#0284c7" />
                    <stop offset="50%" stopColor="#00a0d2" />
                    <stop offset="100%" stopColor="#0284c7" />
                  </linearGradient>
                  <filter id="snowGlow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="1" result="blur" />
                    <feMerge>
                      <feMergeNode in="blur" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                
                {/* Schatten */}
                <ellipse cx="30" cy="78" rx="20" ry="3" fill="rgba(0,0,0,0.1)" />
                
                {/* Untere Kugel - modern gerundet */}
                <ellipse cx="30" cy="62" rx="20" ry="15" fill="url(#snowGrad)" filter="url(#snowGlow)" />
                
                {/* Mittlere Kugel */}
                <ellipse cx="30" cy="40" rx="15" ry="13" fill="url(#snowGrad)" filter="url(#snowGlow)" />
                
                {/* Kopf */}
                <circle cx="30" cy="20" r="14" fill="url(#snowGrad)" filter="url(#snowGlow)" />
                
                {/* Moderne Augen - O2-Style */}
                <circle cx="24" cy="17" r="3" fill="#0c4a6e" />
                <circle cx="36" cy="17" r="3" fill="#0c4a6e" />
                <circle cx="23" cy="16" r="1" fill="white" />
                <circle cx="35" cy="16" r="1" fill="white" />
                
                {/* Karotten-Nase - 3D-Effekt */}
                <polygon points="30,20 30,23 42,21" fill="#f97316" />
                <polygon points="30,20 30,21.5 42,20.5" fill="#fb923c" />
                
                {/* Pustender Mund - O-Form */}
                <ellipse cx="30" cy="28" rx="3" ry="2.5" fill="#374151" className="snowman-mouth-puff" />
                
                {/* Moderner Zylinder mit O2-Blau */}
                <rect x="18" y="5" width="24" height="4" fill="#0c4a6e" rx="1" />
                <rect x="21" y="-5" width="18" height="11" fill="#0c4a6e" rx="2" />
                <rect x="21" y="2" width="18" height="3" fill="#00a0d2" rx="1" />
                
                {/* O2-Schal */}
                <path d="M15 32 Q30 36 45 32" stroke="url(#scarfGrad)" strokeWidth="6" fill="none" strokeLinecap="round" />
                <rect x="40" y="32" width="6" height="18" rx="2" fill="url(#scarfGrad)" />
                <path d="M40 48 Q43 52 46 48" stroke="url(#scarfGrad)" strokeWidth="4" fill="none" />
                
                {/* O2-Logo auf Schal */}
                <circle cx="30" cy="34" r="3" stroke="white" strokeWidth="1" fill="none" />
                <text x="34" y="36" fill="white" fontSize="5" fontWeight="bold">2</text>
                
                {/* Moderne Knöpfe - O2-Cyan */}
                <circle cx="30" cy="45" r="2.5" fill="#0891b2" />
                <circle cx="30" cy="53" r="2.5" fill="#0891b2" />
                <circle cx="30" cy="61" r="2.5" fill="#0891b2" />
                
                {/* Stilisierte Arme */}
                <path d="M10 40 L2 32" stroke="#64748b" strokeWidth="3" strokeLinecap="round" />
                <path d="M4 34 L1 30" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                <path d="M5 35 L2 38" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                
                <path d="M50 40 L58 32" stroke="#64748b" strokeWidth="3" strokeLinecap="round" />
                <path d="M56 34 L59 30" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                <path d="M55 35 L58 38" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
          )}
    </>
  );
}